import {
  Box,
  Button,
  Typography,
  Paper,
  Stack,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Chip,
  IconButton,
} from "@mui/material";
import {
  Delete as DeleteIcon,
  Download as DownloadIcon,
} from "@mui/icons-material";
import { styled } from "@mui/material/styles";
import { RULES_TABLE_CONSTANTS } from "../../Constant/BulkOpsContant";
import "./bulk-upload.css";

const CustomButton = styled(Button)(({ theme }) => ({
  borderColor: "#D31710",
  color: "#D31710",
  "&:hover": {
    backgroundColor: "#FBF5F4",
    borderColor: "#B01309",
    color: "#B01309",
  },
  "&:disabled": {
    backgroundColor: theme.palette.grey[300],
    borderColor: theme.palette.grey[300],
    color: theme.palette.grey[500],
  },
}));

const RulesTable = ({ newRules, setNewRules }) => {
  const onDeleteRule = (id) => {
    const updatedRules = newRules.filter((rule) => rule.id !== id);
    setNewRules(updatedRules);
  };
  const handleExportRules = () => {
    if (newRules.length === 0) {
      alert("No rules to export");
      return;
    }
    const jsonString = JSON.stringify(newRules, null, 2);
    const blob = new Blob([jsonString], { type: "application/json" });
    const url = window.URL.createObjectURL(blob);
    const a = document.createElement("a");
    a.href = url;
    a.download = `validation-rules-${new Date().getTime()}.json`;
    a.click();
    window.URL.revokeObjectURL(url);
  };
  return (
    <div className="my-4">
      <Stack spacing={3}>
        {/* Rules Table */}
        {newRules.length > 0 && (
          <Paper
            elevation={0}
            sx={{
              border: "1px solid #d1d5db",
              borderRadius: 2,
              overflow: "hidden",
            }}
          >
            <Box
              sx={{
                backgroundColor: "#f9fafb",
                px: 3,
                py: 2,
                borderBottom: "1px solid #d1d5db",
                display: "flex",
                alignItems: "center",
                justifyContent: "space-between",
              }}
            >
              <Typography
                variant="h6"
                sx={{
                  color: "#111827",
                  fontSize: "1.125rem",
                  fontWeight: 500,
                }}
              >
                {RULES_TABLE_CONSTANTS.HEADING} ({newRules.length})
              </Typography>
              <CustomButton
                variant="outlined"
                size="small"
                startIcon={<DownloadIcon sx={{ fontSize: "1rem" }} />}
                onClick={handleExportRules}
                sx={{
                  px: 1,
                  py: 0.5,
                  backgroundColor: "white",
                  fontSize: "0.875rem",
                  textTransform: "none",
                }}
              >
                {RULES_TABLE_CONSTANTS.EXPORT_BUTTON}
              </CustomButton>
            </Box>
            <TableContainer>
              <Table sx={{ backgroundColor: "white" }}>
                <TableHead>
                  <TableRow
                    sx={{
                      backgroundColor: "#f3f4f6",
                      borderBottom: "1px solid #d1d5db",
                    }}
                  >
                    {Object.keys(RULES_TABLE_CONSTANTS.HEADERS).length > 0 &&
                      Object.keys(RULES_TABLE_CONSTANTS.HEADERS).map((key) => (
                        <TableCell
                          key={key}
                          sx={{
                            px: 3,
                            py: 2,
                            color: "#374151",
                            fontWeight: 500,
                            fontSize: "0.875rem",
                          }}
                        >
                          {RULES_TABLE_CONSTANTS.HEADERS[key]}
                        </TableCell>
                      ))}
                  </TableRow>
                </TableHead>
                <TableBody>
                  {newRules.map((rule) => (
                    <TableRow
                      key={rule.id}
                      sx={{
                        "&:hover": { backgroundColor: "#f9fafb" },
                        borderBottom: "1px solid #e5e7eb",
                      }}
                    >
                      <TableCell
                        sx={{
                          px: 3,
                          py: 2,
                          color: "#111827",
                          fontSize: "0.875rem",
                        }}
                      >
                        {rule.ruleName}
                      </TableCell>
                      <TableCell
                        sx={{
                          px: 3,
                          py: 2,
                          color: "#374151",
                          fontSize: "0.875rem",
                        }}
                      >
                        {rule.field}
                      </TableCell>
                      <TableCell sx={{ px: 3, py: 2 }}>
                        <Chip
                          label={
                            rule.condition +
                            (rule.condition === "matches regex"
                              ? `: ${rule.regex}`
                              : "")
                          }
                          size="small"
                          sx={{
                            backgroundColor: "#FFDAD4",
                            color: "#D31710",
                            fontSize: "0.75rem",
                            fontWeight: 500,
                            px: 1,
                            py: 0.5,
                            borderRadius: 1,
                          }}
                        />
                      </TableCell>
                      <TableCell align="center" sx={{ px: 3, py: 2 }}>
                        <IconButton
                          onClick={() => onDeleteRule(rule.id)}
                          size="small"
                          title="Delete rule"
                          sx={{
                            color: "#D31710",
                            "&:hover": {
                              color: "#B01309",
                              backgroundColor: "transparent",
                            },
                          }}
                        >
                          <DeleteIcon sx={{ fontSize: "1rem" }} />
                        </IconButton>
                      </TableCell>
                    </TableRow>
                  ))}
                </TableBody>
              </Table>
            </TableContainer>
          </Paper>
        )}
      </Stack>
    </div>
  );
};
export default RulesTable;
